import { Flex } from "@chakra-ui/react"
import styled from "@emotion/styled"

export const StyledFlex = styled(Flex)`
&:hover {
  img {
    -webkit-filter: invert(100%) sepia(56%) saturate(1%) hue-rotate(282deg) brightness(115%) contrast(881%);
            filter: invert(100%) sepia(56%) saturate(1%) hue-rotate(282deg) brightness(115%) contrast(881%);
  }
}

.btn.selected {
  img {
    max-width: unset;
    -webkit-filter: invert(100%) sepia(56%) saturate(1%) hue-rotate(282deg) brightness(115%) contrast(881%);
            filter: invert(100%) sepia(56%) saturate(1%) hue-rotate(282deg) brightness(115%) contrast(881%);
  }
}
`
